// src/pages/Settings.tsx
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRow,
  IonText,
} from '@ionic/react';
import { cardOutline, chevronForward, receiptOutline } from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import TitleBar from '../components/TitleBar.tsx';

const Settings: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage>
      <IonHeader>
        <TitleBar title="Settings" />
      </IonHeader>
      <IonContent className="ion-padding">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol size="12" sizeMd="8" sizeLg="6">
              <IonText className="ion-text-center">
                <h2 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Settings</h2>
                <p style={{ color: '#666', marginBottom: '24px' }}>
                  Manage your billing and usage
                </p>
              </IonText>

              <IonCard style={{ borderRadius: '12px' }}>
                <IonCardContent style={{ padding: 0 }}>
                  <IonList>
                    <IonItem
                      button
                      onClick={() => history.push('/app/settings/billing')}
                      lines="none"
                      style={{ '--padding-start': '16px', '--padding-end': '16px', '--min-height': '64px' }}
                    >
                      <IonIcon
                        icon={cardOutline}
                        slot="start"
                        style={{ fontSize: '28px', color: '#3880ff' }}
                      />
                      <IonLabel>
                        <h2 style={{ fontWeight: '600', fontSize: '16px' }}>Billing</h2>
                        <p style={{ fontSize: '14px', color: '#666' }}>
                          Purchase AI credits
                        </p>
                      </IonLabel>
                      <IonIcon icon={chevronForward} slot="end" style={{ color: '#999' }} />
                    </IonItem>

                    <div style={{ height: '1px', backgroundColor: '#e0e0e0', margin: '0 16px' }} />

                    <IonItem
                      button
                      onClick={() => history.push('/app/settings/usage')}
                      lines="none"
                      style={{ '--padding-start': '16px', '--padding-end': '16px', '--min-height': '64px' }}
                    >
                      <IonIcon
                        icon={receiptOutline}
                        slot="start"
                        style={{ fontSize: '28px', color: '#10dc60' }}
                      />
                      <IonLabel>
                        <h2 style={{ fontWeight: '600', fontSize: '16px' }}>Usage</h2>
                        <p style={{ fontSize: '14px', color: '#666' }}>
                          View credit balance and transactions
                        </p>
                      </IonLabel>
                      <IonIcon icon={chevronForward} slot="end" style={{ color: '#999' }} />
                    </IonItem>
                  </IonList>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Settings;
